// Local
export const MASTERBASEURL = 'https://multitv.bossstudio.tv'; 
// export const BASEURL = 'http://localhost:3000';
// export const DIGITAL_SIGN_SOCKET_BASEURL = "https://digisignsocket.bossstudio.tv";
// export const SOCKET_BASEURL = 'http://localhost:8000';
// export const JOBS_SCHEDULE_BASEURL = 'http://localhost:4000';

// BMS UAT
// export const MASTERBASEURL = 'https://bmsuat.bossstudio.tv'
// export const BASEURL = 'https://bmsuat.bossstudio.tv'
// export const DIGITAL_SIGN_SOCKET_BASEURL = "https://digisignsocket.bossstudio.tv";
// export const SOCKET_BASEURL = 'https://socket.bossstudio.tv'
// export const JOBS_SCHEDULE_BASEURL = 'http://localhost:4000'

// automateB Proud
// export const MASTERBASEURL = 'https://master.bossstudio.tv';
// export const BASEURL = '';
// export const SOCKET_BASEURL = '';
// export const DIGITAL_SIGN_SOCKET_BASEURL = 'https://digisignsocket.bossstudio.tv';
// export const JOBS_SCHEDULE_BASEURL = "";

// export const BASEURL = 'http://192.168.1.8:3000';
// export const DIGITAL_SIGN_SOCKET_BASEURL = "";
// export const MASTERBASEURL = 'http://192.168.1.8:3000';
// export const SOCKET_BASEURL = '';
// export const JOBS_SCHEDULE_BASEURL = 'http://192.168.1.8:4000';

// UAT automateB¸
// export const BASEURL = 'https://uat.bossstudio.tv'
// export const DIGITAL_SIGN_SOCKET_BASEURL = "https://uatdigisignsocket.bossstudio.tv";
// export const MASTERBASEURL = 'https://uat.bossstudio.tv'
// export const SOCKET_BASEURL = '';
// export const JOBS_SCHEDULE_BASEURL = 'https://uat.bossstudio.tv'

// AutomateB¸
// export const BASEURL = 'https://app.automateb.com'
// export const DIGITAL_SIGN_SOCKET_BASEURL = "https://digisignsocket.bossstudio.tv"
// export const MASTERBASEURL = 'https://app.automateb.com'
// export const SOCKET_BASEURL = '';
// export const JOBS_SCHEDULE_BASEURL = 'http://localhost:4000'

// 192.168.1.65 --office